import type { TicketComment as TicketCommentModel } from '@/adapters/catalogv1.g';

export function extractTicketComment(model: TicketCommentModel) {
  return {
    id: model._metadata?.distinct_id ?? '',
    ref: model.comment_ref ?? '',
    ticketRef: model.ticket_ref ?? '',
    body: model.body ?? '',
    authorRef: model.author_ref,
    authorName: model.author_name,
    isInternal: model.is_internal,
    createdAt: model.created_at ? new Date(model.created_at) : undefined,
    tenantId: model._metadata?.tenant_id,
    connectorId: model._metadata?.segment_id,
  };
}

export type CatalogTicketComment = ReturnType<typeof extractTicketComment>;
